// import { Component, Inject, OnInit, ViewChild } from "@angular/core";
// import {
//   MAT_DIALOG_DATA,
//   MatDialog,
//   MatDialogRef,
//   MatPaginator,
//   MatSnackBar,
//   MatTableDataSource,
// } from "@angular/material";
// import { SharedService } from "src/app/shared/services/shared.service";
// import { MentorService } from "../../services/mentors.service";
// import { MentorAuthService } from "../../services/mentor-auth.service";
// import { AmazingTimePickerService } from "amazing-time-picker";
// import {
//   AbstractControl,
//   FormBuilder,
//   FormGroup,
//   NgForm,
//   ValidationErrors,
//   Validators,
// } from "@angular/forms";
// import { Router } from "@angular/router";
// import { ConfirmationDialogComponent } from "../confirmation-dialog/confirmation-dialog.component";
// import * as moment from "moment";
// import Swal from "sweetalert2";

// @Component({
//   selector: "app-schedule-dialog",
//   templateUrl: "./schedule-dialog.component.html",
//   styleUrls: ["./schedule-dialog.component.css"],
// })
// export class ScheduleDialogComponent implements OnInit {
//   options = [
//     { value: "Meeting", label: "Meeting" },
//     { value: "Activity", label: "Activity" },
//   ];
//   scholarsInfo: any = [];
//   meetingList: any = [];
//   displayedColumns = ["Type", "Date", "Time", "Actions"];
//   typeOfMeeting = ["Phone", "Web", "InPerson"];
//   meetingComment: string = "";
//   showTable = false;
//   showMessage = false;
//   showGeneralMessage = false;
//   showSpinner = true;
//   scholarId: any;
//   mentorId: any;
//   time24: any;
//   time: any;
//   @ViewChild(MatPaginator) paginator: MatPaginator;
//   scholarName: any;
//   labelValue: any;
//   selectedOption: string = "Scheduled";
//   meetingForm: FormGroup;
//   documentForm: FormGroup;
//   selectedFiles: File[] | any;
//   fileArray: Object[] = [];
//   showNotebox: boolean = false;
//   showDocument: boolean = false;
//   meetingId: any;
//   date: any;
//   updateStatus: boolean = true;
//   submitted: boolean;
//   currentTime: string;
//   constructor(
//     private sharedService: SharedService,
//     private mentorService: MentorService,
//     private mentorAuthService: MentorAuthService,
//     private atp: AmazingTimePickerService,
//     private _snackBar: MatSnackBar,
//     @Inject(MAT_DIALOG_DATA) public data: any,
//     private dialogRef: MatDialogRef<any>,
//     private dialog: MatDialog,
//     private dialogHandle: MatDialogRef<ScheduleDialogComponent>,
//     private router: Router,
//     private formBuilder: FormBuilder
//   ) {}

//   ngOnInit() {
//     this.getAssignedScholarsInfo();
//     this.meetingForm = this.formBuilder.group({
//       type: ["Meeting", Validators.required],
//       date: ["", Validators.required],
//       time: ["", Validators.required, this.validateTime.bind(this)],
//       goal: ["", Validators.required],
//       progress: ["", Validators.required],
//     });
//     if (this.data.taskDetails) {
//       this.meetingId = this.data.taskDetails.meetingId;
//       this.updateStatus = false;
//       this.selectedOption = this.data.taskDetails.status;
//       this.time = this.data.taskDetails.time;
//       this.meetingForm.get("goal").patchValue(this.data.taskDetails.goal);
//       this.meetingForm.get("type").patchValue(this.data.taskDetails.type);
//       var date = new Date(this.data.taskDetails.date);
//       // Extract the year, month, and day components from the Date object
//       var year = date.getFullYear();
//       var month = date.getMonth() + 1; // Add 1 to the month because it is zero-indexed
//       var day = date.getDate(); // Subtract 1 to get the previous day
//       // Format the date components as strings and add leading zeros if necessary
//       var formattedDate =
//         year +
//         "-" +
//         (month < 10 ? "0" : "") +
//         month +
//         "-" +
//         (day < 10 ? "0" : "") +
//         day;
//       this.date = formattedDate;
//     }
//   }
//   getTypeLabel() {
//     const typeControl = this.meetingForm.get("type");
//     const selectedValue = typeControl.value;
//     return selectedValue === "Meeting" ? "Meeting" : "Activity";
//   }
//   getCurrentTime() {
//     const currentDate = new Date();
//     const currentHour = currentDate.getHours();
//     const currentMinutes = currentDate.getMinutes();
//     let amOrPm = "AM";
//     if (currentHour >= 12) {
//       amOrPm = "PM";
//     }
//     let hour = currentHour % 12;
//     if (hour === 0) {
//       hour = 12;
//     }

//     this.currentTime = `${hour}:${currentMinutes
//       .toString()
//       .padStart(2, "0")} ${amOrPm}`;
//   }
//   close() {
//     if (this.showNotebox == true) {
//       this.showNotebox = false;
//     }
//     if (this.showDocument == true) {
//       this.showDocument = false;
//     }
//   }
//   onFileSelected(event: any) {
//     this.selectedFiles = event.target.files;
//     for (let i = 0; i < this.selectedFiles.length; i++) {
//       const file = this.selectedFiles[i];
//       this.fileArray.push(file.name);
//     }
//   }
//   getAssignedScholarsInfo() {
//     this.mentorService.getAssignedScholars().subscribe(
//       (result: any) => {
//         this.scholarsInfo = result;
//         if (this.data !== "") {
//           const filteredScholars = this.scholarsInfo.filter(
//             (sch: any) => sch.scholarId._id === this.data
//           );
//           if (filteredScholars.length > 0) {
//             this.scholarName = `${filteredScholars[0].scholarId.firstName} ${filteredScholars[0].scholarId.lastName}`;
//           } else {
//             this.scholarName = "";
//           }
//         }
//         if (this.scholarsInfo.length > 0) {
//           this.showGeneralMessage = false;
//           // this.refreshMeetingList(this.data)
//         } else {
//           this.showGeneralMessage = true;
//         }
//       },
//       (error) => {
//         console.log(error);
//       }
//     );
//   }
//   //   refreshMeetingList(id){
//   //     this.showSpinner=true;
//   //     this.showMessage=false;
//   //     this.showTable=false;
//   //     this.sharedService.getScheduledMeetings(id,this.mentorAuthService.getLoggedUserId(),'future').subscribe(
//   //       (result:any)=>{
//   //         this.meetingList=new MatTableDataSource(result)
//   //         this.meetingList.paginator=this.paginator
//   //         if(result.length>=1){
//   //           this.showTable=true;
//   //           this.showMessage=false;
//   //         }
//   //         else{
//   //           this.showTable=false;
//   //           this.showMessage=true;
//   //         }
//   //         this.showSpinner=false;
//   //       },
//   //       (error)=>{
//   //         console.log(error)
//   //       }
//   //     )
//   // }
//   // to schedule meeting with mentor//
//   scheduleOrUpdate() {
//     this.submitted = true; // Set the submitted flag to true
//     if (this.updateStatus == true) {
//       this.schedule();
//     } else if (this.updateStatus == false) {
//       this.updateTask();
//     }
//   }
//   // schedule() {
//   //   if (this.meetingForm.invalid) {
//   //     return;
//   //   }
//   //   if (this.meetingForm.valid) {
//   //     let utc = moment(this.meetingForm.value.date).format(
//   //       "YYYY-MM-DD HH:mm:ss"
//   //     );
//   //     const meetingDetails = {
//   //       scholarId: this.data.id,
//   //       mentorId: this.mentorAuthService.getLoggedUserId(),
//   //       status: this.meetingForm.value.progress,
//   //       date: utc,
//   //       time: this.meetingForm.value.time,
//   //       meetingType: this.meetingForm.value.type,
//   //       goal: this.meetingForm.value.goal,
//   //     };
//   //     this.sharedService.setMeeting(meetingDetails).subscribe((result) => {
//   //       this.openSnackBar("Task Scheduled Successfully", "close");
//   //       this.meetingForm.reset();
//   //       this.dialogRef.close();
//   //       this.router.navigate(["mentor/meetings/notes"]);
//   //     }),
//   //       (error) => {
//   //        console.log(error.error.error)
//   //       };
//   //   } else {
//   //     return false;
//   //   }
//   // }
//   schedule() {
//     if (this.meetingForm.invalid) {
//       return;
//     }

//     if (this.meetingForm.valid) {
//       let utc = moment(this.meetingForm.value.date).format(
//         "YYYY-MM-DD HH:mm:ss"
//       );
//       const meetingDetails = {
//         scholarId: this.data.id,
//         mentorId: this.mentorAuthService.getLoggedUserId(),
//         status: this.meetingForm.value.progress,
//         date: utc,
//         time: this.meetingForm.value.time,
//         meetingType: this.meetingForm.value.type,
//         goal: this.meetingForm.value.goal,
//       };

//       this.sharedService.setMeeting(meetingDetails).subscribe(
//         (result) => {
//           this.openSnackBar("Task Scheduled Successfully", "close");
//           this.meetingForm.reset();
//           this.dialogRef.close();
//           this.router.navigate(["mentor/meetings/notes"]);
//         },
//         (error) => {
//           Swal.fire({
//             text: error.error.error,
//             showCancelButton: true,
//             confirmButtonColor: "#3085d6",
//             cancelButtonColor: "#d33",
//             confirmButtonText: "Yes, cancel it!",
//             cancelButtonText:"No"
//           }).then((result) => {
//             if(result.value===true){
//               console.log( error.error.data)
//               let utc = moment(this.meetingForm.value.date).format("YYYY-MM-DD HH:mm:ss");
//               const meetingDetails = {
//                 meetingId: error.error.data._id,
//                 mentorId: this.mentorAuthService.getLoggedUserId(),
//                 status: "Cancelled",
//                 date: utc,
//                 time: error.error.data.time,
//                 meetingType: error.error.data.meetingType,
//                 goal: error.error.data.goal,
//                 lastUpdatedDate: new Date(),
//               };
//               this.sharedService.updateTask(meetingDetails).subscribe((task) => {
//                 if (task) {
//                   this.openSnackBar("Existing task with same selected time cancelled successfully", "close");
//                 }
//               });
//             }else{
//               console.log("cancelled");
//             }
//           });
//         }
//       );
//     } else {
//       return false;
//     }
//   }

//   updateTask() {
//     if (this.meetingForm.invalid) {
//       return;
//     }
//     let utc = moment(this.meetingForm.value.date).format("YYYY-MM-DD HH:mm:ss");
//     const meetingDetails = {
//       meetingId: this.meetingId,
//       mentorId: this.mentorAuthService.getLoggedUserId(),
//       status: this.meetingForm.value.progress,
//       date: utc,
//       time: this.meetingForm.value.time,
//       meetingType: this.meetingForm.value.type,
//       goal: this.meetingForm.value.goal,
//       lastUpdatedDate: new Date(),
//     };
//     this.sharedService.updateTask(meetingDetails).subscribe((task) => {
//       if (task) {
//         this.openSnackBar("Task Updated Successfully", "close");
//         this.dialog.closeAll();
//       }
//     });
//   }
//   //handle time picker//
//   open() {
//     const amazingTimePicker = this.atp.open();
//     amazingTimePicker.afterClose().subscribe((time) => {
//       this.time24 = time;
//       this.time = this.tConvert(time);
//     });
//     this.getCurrentTime();
//   }
//   //to get minimum selectable date//
//   minDate() {
//     return new Date();
//   }
//   //convert time into AM/PM format//
//   tConvert(time) {
//     time = time
//       .toString()
//       .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];
//     if (time.length > 1) {
//       // If time format correct
//       time = time.slice(1); // Remove full string match value
//       time[5] = +time[0] < 12 ? " AM" : " PM"; // Set AM/PM
//       time[0] = +time[0] % 12 || 12; // Adjust hours
//     }
//     this.time = time.join("");
//     return time.join("");
//   }
//   // validateTime(): Promise<ValidationErrors | null> {
//   //   return new Promise((resolve) => {
//   //     if (!this.time24) {
//   //       resolve({ invalid: true }); // Handle case when time24 is undefined
//   //       return;
//   //     }
//   //     const selectedDate = moment(this.meetingForm.get('date').value);
//   //     const currentDate = moment();
//   //     const scheduledHour = parseInt(this.time24.split(":")[0]);
//   //     const scheduledMinutes = parseInt(this.time24.split(":")[1]);
//   //     if (selectedDate.isSame(currentDate, 'day')) {
//   //       const currentHours = currentDate.hours();
//   //       const currentMinutes = currentDate.minutes();
//   //       if (scheduledHour < currentHours) {
//   //         resolve({ invalid: true });
//   //       } else if (
//   //         scheduledHour === currentHours &&
//   //         scheduledMinutes < currentMinutes
//   //       ) {
//   //         resolve({ invalid: true });
//   //       } else {
//   //         resolve(null);
//   //       }
//   //     } else {
//   //       resolve(null);
//   //     }
//   //   });
//   // }
//   validateTime(): Promise<ValidationErrors | null> {
//   return new Promise((resolve) => {
//     if (!this.time24) {
//       resolve({ invalid: true });
//       return;
//     }

//     const selectedDate = moment(this.meetingForm.get('date').value);
//     const currentDate = moment();

//     // build full datetime with date + time
//     const [scheduledHour, scheduledMinutes] = this.time24.split(":").map(Number);
//     const scheduledDateTime = moment(selectedDate)
//       .set("hour", scheduledHour)
//       .set("minute", scheduledMinutes)
//       .set("second", 0);

//     if (scheduledDateTime.isSameOrBefore(currentDate)) {
//       resolve({ invalid: true });
//     } else {
//       resolve(null);
//     }
//   });
// }


//   // a snck bar used to display action confirmations//
//   openSnackBar(message: string, action: string) {
//     this._snackBar.open(message, action, {
//       duration: 3000,
//     });
//   }
//   onRadioButtonChange(value) {
//     this.labelValue = value;
//     if (this.labelValue === "Meeting" || this.labelValue === "Activity") {
//       this.selectedOption = "Scheduled";
//     }
//   }

//   scheduleMeeting() {
//     const meetingDetails = {
//       meetingId: this.meetingId,
//       scholarId: "",
//       mentorId: this.mentorAuthService.getLoggedUserId(),
//       status: this.meetingForm.value.progress,
//       date: this.meetingForm.value.date,
//       time: this.meetingForm.value.time,
//       meetingType: this.meetingForm.value.type,
//       meetingComment: this.meetingForm.value.notes,
//       goal: this.meetingForm.value.goal,
//       files: this.fileArray,
//     };
//     if (this.data.meetingDetails) {
//       meetingDetails.scholarId = this.data.scholarId;
//     } else {
//       meetingDetails.scholarId = this.data;
//     }
//     this.sharedService.scheduleTask(meetingDetails).subscribe((result) => {
//       this.openSnackBar("Task Updated Successfully", "close");
//       // this.refreshMeetingList(this.data)
//       // this.meetingForm.reset();
//       // this.dialogRef.close();
//       // this.router.navigate(["mentor/meetings/notes"]);
//     }),
//       (error) => {
//         this.openSnackBar(error.error.error, "close");
//       };
//   }
//   saveMeetingNote() {
//     const meetingDetails = {
//       scholarId: this.data,
//       mentorId: this.mentorAuthService.getLoggedUserId(),
//       status: this.meetingForm.value.progress,
//       date: this.meetingForm.value.date,
//       time: this.meetingForm.value.time,
//       meetingType: this.meetingForm.value.type,
//       meetingComment: this.meetingForm.value.notes,
//       goal: this.meetingForm.value.goal,
//       files: this.fileArray,
//     };
//     this.sharedService.setMeeting(meetingDetails).subscribe((result: any) => {
//       this.meetingId = result.meetingId;
//       this.openSnackBar("Task Note Added Successfully", "close");
//       // this.refreshMeetingList(this.data)
//       // this.meetingForm.reset();
//       // this.dialogRef.close();
//       // this.router.navigate(["mentor/meetings/notes"]);
//     }),
//       (error) => {
//         this.openSnackBar(error.error.error, "close");
//       };
//   }
// }
// scholar-info.model.ts
export interface ScholarInfo {
  scholarId: {
    _id: string;
    firstName: string;
    lastName: string;
  };
}


import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatPaginator,
  MatSnackBar,
  MatTableDataSource,
} from "@angular/material";
import { SharedService } from "src/app/shared/services/shared.service";
import { MentorService } from "../../services/mentors.service";
import { MentorAuthService } from "../../services/mentor-auth.service";
import { AmazingTimePickerService } from "amazing-time-picker";
import {
  FormBuilder,
  FormGroup,
  Validators,
  ValidationErrors,
} from "@angular/forms";
import { Router } from "@angular/router";
import * as moment from "moment";
import Swal from "sweetalert2";

@Component({
  selector: "app-schedule-dialog",
  templateUrl: "./schedule-dialog.component.html",
  styleUrls: ["./schedule-dialog.component.css"],
})
export class ScheduleDialogComponent implements OnInit {
  // UI options
  readonly meetingOptions = [
    { value: "Meeting", label: "Meeting" },
    { value: "Activity", label: "Activity" },
  ];
  readonly typeOfMeeting = ["Phone", "Web", "InPerson"];

  // Data
  scholarsInfo: ScholarInfo[] = [];
  meetingList = new MatTableDataSource<any>();
  displayedColumns = ["Type", "Date", "Time", "Actions"];

  // Form
  meetingForm: FormGroup;
  submitted = false;

  // State
  meetingId: string;
  updateMode = false;
  currentTime: string;
  selectedDate: string;
  selectedTime: string;
  fileArray: string[] = [];
  scholarName: string = '';
  selectedOption = "Scheduled";



  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    private sharedService: SharedService,
    private mentorService: MentorService,
    private mentorAuthService: MentorAuthService,
    private atp: AmazingTimePickerService,
    private snackBar: MatSnackBar,
    private router: Router,
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<ScheduleDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this.initForm();
    this.loadScholarsInfo();
    this.setCurrentTime();

    if (this.data.taskDetails) {
      this.patchFormForUpdate(this.data.taskDetails);
    }
    this.meetingForm.get('date').valueChanges.subscribe(() => {
      this.meetingForm.get('time').updateValueAndValidity();
    });
  }

  /** ----------- FORM ----------- **/
  private initForm() {
    this.meetingForm = this.fb.group({
      type: ["Meeting", Validators.required],
      date: ["", Validators.required],
      time: ["", Validators.required, this.validateTime.bind(this)],
      goal: ["", Validators.required],
      progress: ["Scheduled", Validators.required],
    });
  }

  private patchFormForUpdate(task: any) {
    this.updateMode = true;
    this.meetingId = task.meetingId;
    this.selectedTime = task.time;

    this.meetingForm.patchValue({
      type: task.type,
      goal: task.goal,
      progress: task.status,
      date: moment(task.date).format("YYYY-MM-DD"),
      time: task.time,
    });

    this.selectedDate = moment(task.date).format("YYYY-MM-DD");
    this.selectedOption = task.status;
  }

  /** ----------- SCHOLARS ----------- **/
  private loadScholarsInfo(): void {
    this.mentorService.getAssignedScholars().subscribe(
      (result: ScholarInfo[] = []) => {
        this.scholarsInfo = result;

        // Only try to resolve scholar if `data` exists
        if (!this.data) {
          this.scholarName = '';
          return;
        }

        const scholar = this.scholarsInfo.find(
          (sch: ScholarInfo) => sch.scholarId._id === this.data.id
        );

        this.scholarName = scholar
          ? `${scholar.scholarId.firstName} ${scholar.scholarId.lastName}`
          : '';
      },
      error => console.error('Failed to load scholars info:', error)
    );
  }


  /** ----------- DATE / TIME ----------- **/
  private setCurrentTime() {
    const now = moment();
    this.currentTime = now.format("hh:mm A");
  }

  openTimePicker() {
    const picker = this.atp.open();
    picker.afterClose().subscribe((time) => {
      this.selectedTime = this.convertTo12Hour(time);
      this.meetingForm.get("time").setValue(this.selectedTime);
    });
  }

  minDate = new Date();

  private convertTo12Hour(time: string): string {
    return moment(time, "HH:mm").format("hh:mm A");
  }

  validateTime(): Promise<ValidationErrors | null> {
    return new Promise((resolve) => {
      const dateControl = this.meetingForm.get('date');
      const timeControl = this.meetingForm.get('time');

      if (!dateControl || !timeControl || !dateControl.value || !timeControl.value) {
        resolve({ invalid: true });
        return;
      }

      const date: Date = dateControl.value;
      const time: string = timeControl.value;

      const datePart = moment(date).format('YYYY-MM-DD');

      // Correct parsing for 12-hour time format with AM/PM
      const scheduled = moment(`${datePart} ${time}`, 'YYYY-MM-DD hh:mm A');
      const now = moment();

      if (!scheduled.isValid() || scheduled.isSameOrBefore(now)) {
        resolve({ invalid: true });
      } else {
        resolve(null);
      }
    });
  }







  /** ----------- SUBMIT ----------- **/
  onSubmit() {
    this.submitted = true;
    if (this.meetingForm.invalid) return;

    this.updateMode ? this.updateTask() : this.scheduleTask();
  }

  private scheduleTask() {
    const details = this.buildMeetingDetails();
    this.sharedService.setMeeting(details).subscribe(
      () => {
        this.showMessage("Task Scheduled Successfully");
        this.closeDialog();
      },
      (error) => this.handleDuplicateMeeting(error)
    );
  }

  private updateTask() {
    const details = this.buildMeetingDetails(true);
    this.sharedService.updateTask(details).subscribe(() => {
      this.showMessage("Task Updated Successfully");
      this.closeDialog();
    });
  }

  private buildMeetingDetails(isUpdate = false) {
    const formValue = this.meetingForm.value;
    const utcDate = moment(formValue.date).format("YYYY-MM-DD HH:mm:ss");

    return {
      ...(isUpdate && { meetingId: this.meetingId }),
      scholarId: this.data.id,
      mentorId: this.mentorAuthService.getLoggedUserId(),
      status: formValue.progress,
      date: utcDate,
      time: formValue.time,
      meetingType: formValue.type,
      goal: formValue.goal,
      lastUpdatedDate: isUpdate ? new Date() : undefined,
    };
  }

  private handleDuplicateMeeting(error: any) {
    Swal.fire({
      text: error.error.error || "Conflict with existing meeting",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, cancel it!",
      cancelButtonText: "No",
    }).then((result) => {
      if (result.value === true) {
        const existing = error.error.data;
        const cancelDetails = {
          meetingId: existing._id,
          mentorId: this.mentorAuthService.getLoggedUserId(),
          status: "Cancelled",
          date: existing.date,
          time: existing.time,
          meetingType: existing.meetingType,
          goal: existing.goal,
          lastUpdatedDate: new Date(),
        };
        this.sharedService.updateTask(cancelDetails).subscribe(() => {
          this.showMessage(
            "Existing task with same selected time cancelled successfully"
          );
        });
      }
    });
  }

  /** ----------- HELPERS ----------- **/
  private showMessage(msg: string) {
    this.snackBar.open(msg, "Close", { duration: 3000 });
  }

  private closeDialog() {
    this.meetingForm.reset();
    this.dialogRef.close(true);
    this.router.navigate(["mentor/meetings/notes"]);
  }
}

